import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Navbar';
import './index.css';
import { FaWhatsapp, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
// import contactMap from '../../assests/contact-map.png';

const Contact = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    subject: '',
    Message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null); // 'success' or 'error'

  // Refs for scroll reveal
  const headerTitleRef = useRef(null);
  const leftColumnRef = useRef(null);
  const rightColumnRef = useRef(null);
  const footerRef = useRef(null);



  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const response = await fetch('https://www.whysocial.in/lavanya_shankar_api/contactReq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      let data;

      if (contentType && contentType.includes('application/json')) {
        data = await response.json();
      } else {
        data = await response.text();
      }

      console.log('API Response:', data);

      if (response.ok) {
        setSubmitStatus('success');
        // Reset form after successful submission
        setFormData({
          fullName: '',
          lastName: '',
          email: '',
          phoneNumber: '',
          subject: '',
          Message: ''
        });
        // Clear success message after 5 seconds
        setTimeout(() => {
          setSubmitStatus(null);
        }, 5000);
      } else {
        setSubmitStatus('error');
        console.error('Form submission failed:', data);
      }
    } catch (error) {
      setSubmitStatus('error');
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };



  // Intersection Observer for Scroll Reveal
  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    // Observe all sections
    const sections = [
      headerTitleRef.current,
      leftColumnRef.current,
      rightColumnRef.current,
      footerRef.current
    ];

    sections.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    // Cleanup
    return () => {
      sections.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  return (
    <div className="contactpage-container">
      {/* Shared Navigation Header */}
      <Navbar />

      {/* Main Content */}
      <main className="contactpage-main">
        {/* Main Title - Centered */}
        <div ref={headerTitleRef} className="contactpage-header-title reveal-section reveal-fade">
          <h1 className="contactpage-main-title">
            EVERY GREAT DESIGN BEGINS<br />
            WITH A <span className="contactpage-title-bold">DIALOGUE</span>
          </h1>
        </div>

        <div className="contactpage-content-wrapper">

          {/* Left Column - Contact Information */}
          <div ref={leftColumnRef} className="contactpage-left-column reveal-section reveal-left">

            {/* Address Section */}
            <div className="contactpage-info-section">
              <h3 className="contactpage-info-title">ADDRESS</h3>
              <div className="contactpage-info-item">
                <FaMapMarkerAlt className="contactpage-icon" />
                <div className="contactpage-info-text">
                  <p>Lavanya & Shankar Architects</p>
                  <p>Baid Metha Complex, C - Block</p>
                  <p>3rd Floor, Old No. 183, New No. 16,</p>
                  <p>Anna Salai, Saidapet, Chennai - 15</p>
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="contactpage-info-section">
              <h3 className="contactpage-info-title">CONTACT</h3>
              <div className="contactpage-info-item">
                <FaPhoneAlt className="contactpage-icon" />
                <div className="contactpage-info-text">
                  <p>91 44 22201055 / 91 44 22201066</p>
                </div>
              </div>
              <div className="contactpage-info-item">
                <FaEnvelope className="contactpage-icon" />
                <div className="contactpage-info-text">
                  <p>shankar@lavanyaandshankar.com</p>
                  <p>lavanya@lavanyaandshankar.com</p>
                </div>
              </div>
            </div>

            {/* Careers Section */}
            <div className="contactpage-info-section">
              <h3 className="contactpage-info-title">CAREERS</h3>
              <div className="contactpage-info-item">
                <FaEnvelope className="contactpage-icon" />
                <div className="contactpage-info-text">
                  <p>career.lsarchitects@gmail.com</p>
                </div>
              </div>
            </div>

            {/* Map Container with Embedded Map */}
            <div className="contactpage-map-container">
              <div className="contactpage-map-iframe-wrapper" style={{ position: 'relative', height: '300px', width: '100%', overflow: 'hidden' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7774.6493374275915!2d80.222797!3d13.014985!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52670d025190fd%3A0xf59a951faebc56fb!2sLavanya%20and%20Shankar%20Architects!5e0!3m2!1sen!2sus!4v1762166333322!5m2!1sen!2sus"
                  width="100%"
                  height="300"
                  style={{ border: 0, position: 'absolute', top: 0, left: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Map of Lavanya and Shankar Architects"
                ></iframe>
              </div>
            </div>

          </div>

          {/* Right Column - Contact Form */}
          <div ref={rightColumnRef} className="contactpage-right-column reveal-section reveal-right">

            <div className="contactpage-form-wrapper">
              <h2 className="contactpage-form-title">LET'S BEGIN THE DIALOGUE</h2>
              <p className="contactpage-form-description">
                Share your vision with us—whether it's a custom piece, a collaboration, or a consultation. Let's bring timeless design to life.
              </p>

              <form className="contactpage-form" onSubmit={handleSubmit}>
                <div className="contactpage-form-row">
                  <input
                    type="text"
                    name="fullName"
                    placeholder="Full Name*"
                    value={formData.fullName}
                    onChange={handleInputChange}
                    className="contactpage-input"
                    required
                  />
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    className="contactpage-input"
                  />
                </div>

                <div className="contactpage-form-row">
                  <input
                    type="email"
                    name="email"
                    placeholder="Email*"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="contactpage-input"
                    required
                  />
                  <input
                    type="tel"
                    name="phoneNumber"
                    placeholder="Phone Number*"
                    value={formData.phoneNumber}
                    onChange={handleInputChange}
                    className="contactpage-input"
                    required
                  />
                </div>

                <div className="contactpage-form-row">
                  <input
                    type="text"
                    name="subject"
                    placeholder="Subject"
                    value={formData.subject}
                    onChange={handleInputChange}
                    className="contactpage-input contactpage-input-full"
                  />
                </div>

                <div className="contactpage-form-row">
                  <textarea
                    name="Message"
                    placeholder="Message*"
                    value={formData.Message}
                    onChange={handleInputChange}
                    className="contactpage-textarea"
                    rows="6"
                    required
                  ></textarea>
                </div>

                {/* Status Messages */}
                {submitStatus === 'success' && (
                  <div className="contactpage-success-message">
                    Thank you! Your message has been sent successfully. We'll get back to you soon.
                  </div>
                )}
                {submitStatus === 'error' && (
                  <div className="contactpage-error-message">
                    Oops! Something went wrong. Please try again later.
                  </div>
                )}

                <button type="submit" className="contactpage-submit-button" disabled={isSubmitting}>
                  {isSubmitting ? 'SENDING...' : 'SUBMIT'}
                </button>
              </form>
            </div>

          </div>

        </div>
      </main >

      {/* Footer */}
      < footer ref={footerRef} className="contactpage-footer reveal-section reveal-bottom" >
        <div className="contactpage-footer-content">
          <p className="contactpage-copyright">
            Copyright @ 2025. LAVANYA AND SHANKAR. All Rights Reserved.
          </p>

          {/* Social Media Icons */}
          <div className="contactpage-social-icons">
            <a
              href="https://wa.me/919884072874"
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link whatsapp"
            >
              <FaWhatsapp />
            </a>
            <a
              href="https://www.instagram.com/lavanyaandshankar_architects?igsh=MW5uY3R5MmI3cmF6NA=="
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://www.linkedin.com/company/lavanya-shankar-architects/"
              target="_blank"
              rel="noopener noreferrer"
              className="contactpage-icon-link linkedin"
            >
              <FaLinkedinIn />
            </a>
          </div>
        </div>
      </footer >
    </div >
  );
};

export default Contact;






